// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"buttons_btnBlue__FY89U","btnWhite":"buttons_btnWhite__tUVY4 buttons_btnBlue__FY89U"};